module.exports = __webpack_public_path__ + "media/packs/images/flags/IQ-4f9d533fedbb05c9f4d28673939c46ca.svg";